import React from 'react';

import { flagStyles } from '../settings';

const SvgNI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3912px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNI;
